export const queryKeys = {
  auth: {
    session: ["auth", "session"] as const,
  },
  companies: {
    all: ["companies"] as const,
    detail: (id: string) => ["companies", id] as const,
    dashboard: (id: string) => ["companies", id, "dashboard"] as const,
    labels: (id: string) => ["companies", id, "labels"] as const,
    issues: (id: string, filters?: Record<string, unknown>) =>
      ["companies", id, "issues", filters ?? {}] as const,
    knowledge: (id: string) => ["companies", id, "knowledge"] as const,
    knowledgeOne: (id: string, kbId: string) => ["companies", id, "knowledge", kbId] as const,
    knowledgeOnboarding: (id: string) => ["companies", id, "knowledge", "by-type", "onboarding"] as const,
  },
  issues: {
    detail: (id: string) => ["issues", id] as const,
  },
};
